import { Item } from '../../models/order/item.js'
export default {
    // list: state => state.itemList,
    detail: state => state.itemDetail,
    list: state => {
        let temp = [];
        if(state.itemList && state.itemList.items) {
            for (let i = 0; i < state.itemList.items.length; i++) {
              temp.push(new Item(state.itemList.items[i]));
            }
        }
        return temp;
      },
}
